export enum StaffBtnLabel {
  COMPLETE = "complete",
  CAN_NOT = "can_not",
  FORWARD = "forward",
  HELP = "help",
  RESPOND = "respond",
  CANCEl = "cancel",
}

export enum BizConversationState {
  IDLING = "idling",
  CALLING = "calling",
  FORWARDING = "forwarding",
  CHATTING_GUEST = "chatting_guest",
  CHATTING_STAFF = "chatting_staff",
  BUSY = "busy",
  OUT_OF_BUSINESS = "out_of_business",
  CLOSE_GUEST = "close_guest",
  CLOSE_STAFF = "close_staff",
  CLOSE_TIMEOUT = "close_timeout",
}

export enum BizConversationInfoStateDirection {
  // 自分が
  I = "i",
  // 自分から
  FROM_ME = "from_me",
  // 自分or自分のグループに対して
  TO_ME = "to_me",
  // それ以外
  OTHERS = "others",
}

export type StaffBtn = {
  state: string;
  assigned_id_account: number;
  guest: {
    left: string;
    right: string;
  };
  staff: {
    left: string;
    right: string;
  };
};

export type BaseElement = {
  label: string;
  payload: string;
};

export type OrderedBaseElement = {
  order: number;
  label: string;
  payload: string;
};

export type ButtonUnitElement = {
  order: number;
  is_reversed: boolean;
  label: string;
  payload: string;
};

export type ListItem = {
  label: string;
  payload: string;
  disabled: boolean;
};

export type SelectioNumber = {
  start: number;
  end: number;
};

export type Label = {
  label: string;
};

export type TableItem = {
  name_dict: string;
  name_label: string;
  type_dict: string;
  type_label: string;
  price: number;
  index: number;
  order: number;
};

export type TscanSettings = {
  project_cd: string;
  rich_list: number;
  read_only: number;
};

export type SelectionMessage = {
  input_type: string;
  buttons: ButtonUnitElement[];
  list: BaseElement[];
  number: SelectioNumber;
  items: TableItem[];
  tscan_settings: TscanSettings;
  submit: Label;
  can_skip: boolean;
  skip: BaseElement;
  default: ListItem;
  can_order: boolean;
  type: string;
};
